<script setup lang="ts">
import { saveList } from '../utils/helper';

//components
import InputSearch from '@/core/components/form/InputSearch.vue';

//composable
import { useProductPickerStore } from '../composable/useProductPickerStore';

//hooks
const { resetSearchData, setQuery, setQueryList, setLoading, isLoading, cachedQueryList } = useProductPickerStore();

//data
const currentQuery = ref('');
const previousQuery = ref('');
const timeOut = ref<NodeJS.Timeout | undefined>();

//props
const props = defineProps({
  scrollBarRef: Object,
});

onMounted(() => {
  setQuery(currentQuery.value);
});

watch(currentQuery, (newValue, oldValue) => {
  if (newValue.length === 0) {
    setQuery(currentQuery.value);
    resetSearchData();
  }
  if (oldValue.length > 0 && newValue.length === 0) {
    previousQuery.value = '';
  }
});

const resetScroll = () => {
  const container = document.querySelector('.product-picker_body');
  if (container && container.scrollTop !== 0) container.scrollTop = 0;
};

const localSearch = () => {
  const localData = cachedQueryList.value.filter((item: { title: string }) =>
    item.title.toLowerCase().includes(currentQuery.value.toLowerCase()),
  );
  if (localData.length > 0) {
    setQueryList(localData);
  }
  setLoading(false);
};

const delaySearch = () => {
  const query = currentQuery.value?.toLowerCase().trim() || '';
  const isNotChangeQuery = query === previousQuery.value;
  if (query.length === 0 || isNotChangeQuery) return;
  setLoading(true);
  if (timeOut.value) clearTimeout(timeOut.value);
  timeOut.value = setTimeout(() => {
    resetScroll();
    setQuery(query);
    previousQuery.value = query;
    resetSearchData();
    localSearch();
  }, 500);
};
</script>

<template>
  <InputSearch
    v-model="currentQuery"
    :placeholder="'Search products'"
    :searching="isLoading && currentQuery.length > 0"
    clear
    @input="delaySearch" />
</template>

<style scoped></style>
